import { ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { BadgeTemplateClassifierData } from '@juvare/badging/backend/config/classifiers/badge-template-classifier/types';
import { BadgeData } from '@juvare/badging/backend/features/badges/shared';
import { z } from 'zod';

export const formSettingsSchema = z.object({
    badgeDocumentName: z.string(),
    description: z.string(),
    showBarcode: z.boolean(),
    showOccupation: z.boolean(),
    showHairColor: z.boolean(),
    badgeLabel: z.string(),
    showIssuedDate: z.boolean(),
    defaultExpirationInterval: z.number(),
    affiliation: z.string(),
    nameOrder: z.enum(['firstName', 'lastName']),
    showExpirationDate: z.boolean(),
    returnAddress: z.string(),
    showEyeColor: z.boolean(),
    showHeight: z.boolean(),
    showDateOfBirth: z.boolean(),
    badgeTitle: z.string(),
    showFullName: z.boolean(),
    disclaimer: z.string(),
    showAffiliation: z.boolean(),
    showEcl: z.boolean(),
    showStateLicenseNumber: z.boolean(),
});
export type RmsBadgeTemplateFormSettings = z.infer<typeof formSettingsSchema>;

export interface RmsBadgeTemplateClassifierData extends BadgeTemplateClassifierData {
    defaultSampleAccountData: ExtendedAccountData;
    defaultFormSettings: RmsBadgeTemplateFormSettings;
}

export type RmsBadgeTemplateData = {
    badgeLabel?: string;
    badgeTitle?: string;
    disclaimer?: string;
    issueDate?: string;
    expirationDate?: string;
    nameFirstLine?: string;
    nameSecondLine?: string;
    returnAddress?: string;
    organization?: string;
    affiliation?: string;
    dateOfBirth?: string;
    occupation?: string;
    height?: string;
    hairColor?: string;
    eyeColor?: string;
    profileImage?: string;
    badgeNumber?: string;
};

export interface RmsAccountOptions {
    occupationId?: string;
    organizationId?: string;
}

export type RmsBadgeData = Omit<BadgeData, 'formSettings' | 'templateSnapshot'> & {
    formSettings: RmsBadgeTemplateFormSettings;
    templateSnapshot: {
        id: string;
        data: RmsBadgeTemplateClassifierData;
    };
};
